var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_12935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8111 0.578117C7.57544 0.832 1.56437 6.47717 0.86993 13.683C0.728054 15.1241 0.8102 16.5205 1.06408 17.8571C1.06408 17.8571 1.08647 18.0139 1.16115 18.3126C1.38516 19.3132 1.72119 20.2839 2.13935 21.1949C3.59544 24.6448 6.96313 30.4169 14.5199 36.6967C14.9829 37.085 15.6624 37.085 16.1328 36.6967C23.6896 30.4243 27.0572 24.6522 28.5208 21.1875C28.9464 20.2765 29.275 19.3132 29.499 18.3051C29.5662 18.0139 29.5961 17.8496 29.5961 17.8496C29.7678 16.9536 29.8574 16.0351 29.8574 15.0943C29.8574 6.89533 23.0698 0.286898 14.8111 0.578117ZM15.3263 22.3225C11.4285 22.3225 8.26988 19.1639 8.26988 15.266C8.26988 11.3682 11.4285 8.20955 15.3263 8.20955C19.2242 8.20955 22.3828 11.3682 22.3828 15.266C22.3828 19.1639 19.2242 22.3225 15.3263 22.3225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_12935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.0566,
    height: 36.4191,
    fill: "white",
    transform: "translate(0.800781 0.568848)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b57f6750dba701bedbedc519277a4726.svg";
export { ForwardRef as ReactComponent };